import React from 'react';
import { isImage, isVideo, isSupportedVideoFormat, isSupportedImageFormat } from '../utils/mediaUtils';

const MediaRenderer = ({ 
  src, 
  alt = '', 
  className = '', 
  style = {},
  controls = true,
  autoPlay = false,
  muted = true,
  loop = false,
  poster = null,
  onError = null,
  loading = 'lazy'
}) => {
  if (!src) {
    return (
      <div className={`media-placeholder ${className}`} style={style}>
        <div className="text-center">
          <i className="bi bi-file-earmark display-4 text-muted mb-2"></i>
          <p className="text-muted mb-0">Medya Bulunamadı</p>
        </div>
      </div>
    );
  }

  const handleError = (e) => {
    console.error('MediaRenderer - Medya yükleme hatası:', src);
    console.error('MediaRenderer - Hata detayları:', {
      src: src,
      error: e.target.error,
      status: e.target.naturalWidth || 'N/A',
      complete: e.target.complete
    });
    
    if (onError) {
      onError(e);
    } else {
      // Varsayılan hata işleme
      e.target.style.display = 'none';
      const placeholder = e.target.nextSibling;
      if (placeholder && placeholder.classList.contains('media-error-placeholder')) {
        placeholder.style.display = 'flex';
      }
    }
  };

  if (isImage(src) && isSupportedImageFormat(src)) {
    return (
      <>
        <img
          src={src}
          alt={alt}
          title={alt || "Işıltı Saz Evi - Müzik Enstrümanı"}
          className={`media-image ${className}`}
          style={style}
          loading={loading}
          onError={handleError}
        />
        <div 
          className="media-error-placeholder d-flex align-items-center justify-content-center"
          style={{ 
            display: 'none', 
            ...style,
            backgroundColor: '#f8f9fa',
            border: '2px dashed #dee2e6',
            borderRadius: '8px'
          }}
        >
          <div className="text-center">
            <i className="bi bi-image-fill display-4 text-muted mb-2"></i>
            <p className="text-muted mb-0">Resim Yüklenemedi</p>
          </div>
        </div>
      </>
    );
  }

  if (isVideo(src) && isSupportedVideoFormat(src)) {
    return (
      <>
        <video
          src={src}
          className={`media-video ${className}`}
          style={style}
          controls={controls}
          autoPlay={autoPlay}
          muted={muted}
          loop={loop}
          poster={poster}
          onError={handleError}
          preload="metadata"
          title={alt || "Işıltı Saz Evi - Müzik Enstrümanı Videosu"}
          aria-label={alt || "Işıltı Saz Evi - Müzik Enstrümanı Videosu"}
        >
          <source src={src} type={`video/${src.split('.').pop()}`} />
          Tarayıcınız video oynatmayı desteklemiyor.
        </video>
        <div 
          className="media-error-placeholder d-flex align-items-center justify-content-center"
          style={{ 
            display: 'none', 
            ...style,
            backgroundColor: '#f8f9fa',
            border: '2px dashed #dee2e6',
            borderRadius: '8px'
          }}
        >
          <div className="text-center">
            <i className="bi bi-play-circle-fill display-4 text-muted mb-2"></i>
            <p className="text-muted mb-0">Video Yüklenemedi</p>
          </div>
        </div>
      </>
    );
  }

  // Desteklenmeyen format
  return (
    <div className={`media-unsupported ${className}`} style={style}>
      <div className="text-center">
        <i className="bi bi-question-circle display-4 text-warning mb-2"></i>
        <p className="text-muted mb-0">Desteklenmeyen Format</p>
        <small className="text-muted">{src.split('.').pop().toUpperCase()}</small>
      </div>
    </div>
  );
};

export default MediaRenderer;
